module.exports = __webpack_public_path__ + "static/media/iconService3.ef102a74.svg";